import { SvgIcon } from "@mui/material";

export default function StepThroughIcon() {
    return (
        <SvgIcon viewBox="0 0 16 16">
            <path d="M9.53,8.0L9.53,7.46L5.63,3.55L4.57,4.61L7.18,7.25L1.0,7.25L1.0,8.75L7.18,8.75L4.57,11.39L5.63,12.45L9.53,8.54L9.53,8.0Z M15.01,8.04a2,2 0 1,1 -4,0a2,2 0 1,1 4,0Z" />
        </SvgIcon>
    );
}
